
import React from 'react';
import { BlogPost } from '@/services/blog/types';
import { Separator } from '@/components/ui/separator';
import { Badge } from '@/components/ui/badge';
import { formatHtmlContent } from '@/services/blog/blogUtils';

interface BlogContentProps {
  post: BlogPost;
}

export const BlogContent: React.FC<BlogContentProps> = ({ post }) => {
  // Format the HTML content to ensure proper paragraph structure
  const formattedContent = formatHtmlContent(post.content);
  
  return (
    <div>
      {post.featured_image && (
        <div className="mb-10">
          <img 
            src={post.featured_image} 
            alt={post.title}
            className="w-full h-auto rounded-lg shadow-md"
            onError={(e) => {
              console.error('Featured image failed to load:', post.featured_image);
              (e.target as HTMLImageElement).src = 'https://via.placeholder.com/1200x630?text=Image+Not+Found';
            }}
          />
        </div>
      )}
      
      <Separator className="my-8" />
      
      <article className="prose prose-lg max-w-none">
        <div 
          dangerouslySetInnerHTML={{ __html: formattedContent }} 
          className="blog-content"
        />
      </article>
      
      <Separator className="my-8" />
      
      <div className="mt-8">
        <h3 className="text-lg font-semibold mb-2">Tags</h3>
        <div className="flex flex-wrap gap-2">
          {post.tags?.map((tag, i) => (
            <Badge key={i} variant="secondary">{tag}</Badge>
          ))}
        </div>
      </div>
    </div>
  );
};
